/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _EditCommentFormContainer_comment$ref: unique symbol;
export type EditCommentFormContainer_comment$ref = typeof _EditCommentFormContainer_comment$ref;
export type EditCommentFormContainer_comment = {
    readonly id: string;
    readonly body: string | null;
    readonly createdAt: string;
    readonly author: {
        readonly username: string | null;
    } | null;
    readonly editing: {
        readonly editableUntil: string | null;
    };
    readonly " $refType": EditCommentFormContainer_comment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "EditCommentFormContainer_comment",
    "type": "Comment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "body",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "author",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "username",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "editing",
            "storageKey": null,
            "args": null,
            "concreteType": "EditInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "editableUntil",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '3f8c47e79b937dbba3702210ba3765ec';
export default node;
